import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from '@/common/Toast';

interface IContextParameters {
  message: string;
  duration?: number;
  showCheckmark?: boolean;
  status?: 'info' | 'success' | 'error';
}

type ToastContextType = {
  // eslint-disable-next-line no-unused-vars
  showToast: (params: IContextParameters) => void;
};

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const [checkmark, setCheckmark] = useState(false);
  const [status, setStatus] = useState('');

  const showToast = useCallback((params: IContextParameters) => {
    setToastMessage(params.message);
    setCheckmark(params.showCheckmark ?? false);
    setStatus(params.status || 'info');
    setTimeout(() => setToastMessage(null), params.duration || 3000);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toastMessage && <Toast message={toastMessage} checkmark={checkmark} status={status} />}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) throw new Error('useToast must be used within a ToastProvider');
  return context;
};
